<template>
  <div 
    ref="viewer" 
    style="width:100%; height:100vh; position: absolute; left: 0; right: 0; top: 0; bottom: 0" 
    data-bind="dxReportViewer: $data">
  </div>
</template>

<script>
import ko from "knockout";
import "devexpress-reporting/dx-webdocumentviewer";
import { domain } from '@/gloabelConstant.js'

export default {
  name: "InvestorOpportunities",

mounted() {

    const investorId = Number(this.$route.params.InvestorID) || 0;
    const reportName = "InvestorOpportunities";
    const fullReportUrl = `${reportName}?InvestorID=${investorId}`;

    var viewerOptions = {
        reportUrl: ko.observable(fullReportUrl), 
        requestOptions: {
            host: domain, 
            invokeAction: "DXXRDV", 
        },
        callbacks: {

            ParametersInitialized: (s, e) => {
                e.ActualParameters.forEach(p => {
                    if (p.Path === "InvestorID") p.Value(investorId);
                    if (p.Path === "statusId") p.Value(statusId);
                });
                
         
                s.GetParametersModel().showParameters(false);
                
          
                s.SubmitParameters();
            }
        }
    };

    ko.applyBindings(viewerOptions, this.$refs.viewer);
},
callbacks: {
    BeforeRender: (s, e) => {
    
        s.GetParametersModel().showParameters(false);
    },
    ParametersInitialized: (s, e) => {
        e.ActualParameters.forEach(p => {
            if (p.Path === "InvestorID") p.Value(Number(investorId));
            if (p.Path === "statusId") p.Value(Number(statusId));
        });

    
        setTimeout(() => {
            s.SubmitParameters();
        }, 1); 
    }
},
  beforeDestroy() {

    if (this.$refs.viewer) {
      ko.cleanNode(this.$refs.viewer);
    }
  } 
};
</script>